import React from 'react';
import { B } from '../constants';

export function GBIcon({ size = 40, bg = B.forest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 58 58" fill="none">
      <circle cx="29" cy="29" r="29" fill={bg} />
      <path d="M12 36 Q29 16 46 36" stroke={B.amber} strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <g transform="translate(29,27) rotate(-30)">
        <path d="M0-9 L3 0 L0 2 L-3 0 Z" fill="white" />
        <path d="M-7 1 L0 0 L7 1 L0 3 Z" fill="white" opacity="0.85" />
        <path d="M-3 2 L0 2.5 L3 2 L0 4 Z" fill="white" opacity="0.7" />
      </g>
      <circle cx="16" cy="42" r="1.8" fill={B.mint} />
      <circle cx="22" cy="44" r="1.8" fill={B.mint} />
      <circle cx="29" cy="45" r="1.8" fill={B.mint} />
      <circle cx="36" cy="44" r="1.8" fill={B.mint} />
      <circle cx="42" cy="42" r="1.8" fill={B.mint} />
    </svg>
  );
}

export function GBWordmark({ size = 'md' }) {
  const s = { sm: [32,20,22], md: [42,28,30], lg: [58,38,42] }[size] || [42,28,30];
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
      <GBIcon size={s[0]} />
      <div style={{ lineHeight: 1 }}>
        <div style={{ fontFamily: "'Montserrat',sans-serif", fontWeight: 900, fontSize: s[1], textTransform: 'uppercase', letterSpacing: -0.5, color: 'white', lineHeight: 1 }}>
          <span style={{ color: B.mint }}>G</span>REAT
        </div>
        <div style={{ fontFamily: "'Playfair Display',serif", fontWeight: 700, fontStyle: 'italic', fontSize: s[2], color: B.amber, lineHeight: 1, marginTop: -2 }}>
          Break
        </div>
      </div>
    </div>
  );
}
